// extracted by mini-css-extract-plugin
module.exports = {"column":"LoadingFlag_column__5x1tW","svg":"LoadingFlag_svg__sGYZw"};